import {SelectProps} from '@amzn/awsui-components-react/polaris/select';
import {
    WorkflowInputSchema,
    WorkflowOutputSchema,
    WorkflowParameterType,
    WorkflowResponse,
} from '../../backend/model';
import {authToken} from "../../backend/apiClient";
import jwt_decode from "jwt-decode";
import {fetchWorkflows} from "../../backend/backend";

export interface Workflow extends SelectProps.Option {
    regions: Set<string>
    exampleInput: string
    exampleBatchInput: string
    value: string
    inputs: WorkflowInputSchema[]
    outputs: WorkflowOutputSchema[]
    deprecated: boolean
}

export async function getWorkflows(all: boolean = true): Promise<Workflow[]> {
    let response
    if (all) {
        response = (await fetchWorkflows()).data
    } else {
        const token = await authToken
        if (token === process.env.REACT_APP_AUTH_TOKEN) {
            response = (await fetchWorkflows("GuardrailsIntegrationTest_APA", "ApplicationName")).data
        } else {
            response = (await fetchWorkflows(jwt_decode<any>(token as string).sub, "UserId")).data
        }
    }

    return response.workflows.map(workflow => createWorkflow(workflow))
}

function createWorkflow(workflow: WorkflowResponse): Workflow {
    const exampleInput = createExampleInput(workflow)

    return {
        label: workflow.tags['prettyName'],
        value: workflow.workflowName,
        regions: new Set(workflow.regions),
        exampleInput: exampleInput,
        exampleBatchInput: createExampleBatchInput(exampleInput),
        inputs: workflow.input,
        outputs: workflow.output,
        deprecated: workflow.tags['deprecated'] === 'true',
    }
}

function createExampleInput(workflow: WorkflowResponse): string {
    const exampleInput: any = {}
    workflow.input.forEach(function(input) {
        const parameterName = input.parameterName
        const exampleValue = input.exampleValue
        switch (input.type) {
            case WorkflowParameterType.BOOLEAN:
            case WorkflowParameterType.INT:
                exampleInput[parameterName] = JSON.parse(exampleValue)
                break
            case WorkflowParameterType.MAP_LIST_STRING:
                // Only works for a single key/value in the map
                const mapListSplit = exampleValue.substring(1, exampleValue.length - 1).split('=')
                const formattedExampleValue = `{${JSON.stringify(mapListSplit[0])}:${JSON.stringify(parseListString(mapListSplit[1]))}}`
                exampleInput[parameterName] = JSON.parse(formattedExampleValue)
                break
            case WorkflowParameterType.LIST_STRING:
                exampleInput[parameterName] = parseListString(exampleValue)
                break
            case WorkflowParameterType.LIST_LONG:
                exampleInput[parameterName] = exampleValue.substring(1, exampleValue.length - 1).split(',').map(long =>BigInt(long))
                break
            case WorkflowParameterType.LONG:
                exampleInput[parameterName] = BigInt(exampleValue)
                break
            case WorkflowParameterType.STRING:
            default:
                exampleInput[parameterName] = exampleValue
        }
    })

    return JSON.stringify(exampleInput, (_, value) =>
        typeof value === 'bigint'
            ? `${value}#bigint`
            : value, 4).replace(/"(-?\d+)#bigint"/g, (_, a) => a)
}

function parseListString(list: string): string[] {
    return list.substring(1, list.length - 1).split(',').map(str => str.trim())
}

function createExampleBatchInput(exampleInput: string): string {
    return `
[
${exampleInput.replace(/^(.)/gm, '    $1')},
    ...
]`
}
